import styled from 'styled-components';

import { tokens } from '../../../../tokens';

export const FooterWrapper = styled.div`
    flex: 0 0 auto;
    padding-left: ${tokens.spacing.tight}px;
    padding-right: ${tokens.spacing.tight}px;
    padding-bottom: ${tokens.spacing.tight}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-left: ${tokens.spacing.loose}px;
        padding-right: ${tokens.spacing.loose}px;
    }
`;
